module.exports = __webpack_public_path__ + "static/media/History_Banner.0b036d2d.png";